import { render, staticRenderFns } from "./client-app-bar.component.vue?vue&type=template&id=3d84bb3a&scoped=true"
import script from "./client-app-bar.component.ts?vue&type=script&lang=ts&external"
export * from "./client-app-bar.component.ts?vue&type=script&lang=ts&external"
import style0 from "./client-app-bar.component.vue?vue&type=style&index=0&id=3d84bb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d84bb3a",
  null
  
)

export default component.exports